import { render, staticRenderFns } from "./UserPromocodes.vue?vue&type=template&id=4a91470f&scoped=true&"
import script from "./UserPromocodes.vue?vue&type=script&lang=js&"
export * from "./UserPromocodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a91470f",
  null
  
)

export default component.exports